<template>
  <pt-life-experience-pavilion-invoice class="pt-life-experience-pavilion-invoice__page"></pt-life-experience-pavilion-invoice>
</template>

<script>
import PtLifeExperiencePavilionInvoice from 'cps/appointment-application/pt-life-experience-pavilion-invoice/withData'
export default {
  name: 'pt-life-experience-pavilion-invoice__view',
  components: {
    'pt-life-experience-pavilion-invoice': PtLifeExperiencePavilionInvoice
  }
}
</script>
